// Components
import BarChartCard from "@/components/Dashboard/barChartCard";
import GaugeChartCard from "@/components/Dashboard/gaugeChartCard";
import LineChartCard from "@/components/Dashboard/lineChartCard";
import SparkLineChartCard from "@/components/Dashboard/sparkLineChartCard";
import TrendCard from "@/components/Dashboard/trendCard";
import ProductAutoComplete from "@/components/Filter/productAutocomplete";
import Layout from "@/components/layout";
import {
  getMaxDate,
  getProducts as getStatisticsProduct,
  getSummaryByBrand,
  getSummaryByProduct,
} from "@/fetch/fetchStatistics";
import currencyFormat from "@/lib/currencyFormat";
import { enumerateDaysBetweenDates } from "@/lib/enumerateDaysBetweenDates";
import getRandomColor from "@/lib/getRandomColor";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { cheerfulFiestaPalette } from "@mui/x-charts/colorPalettes";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import _ from "lodash";
import moment from "moment";
import React from "react";
// Mui
const ManningsDashBoardPage = (props) => {
  const { open, setOpen } = props;
  const [lastUpdatedDate, setLastUpdatedDate] = React.useState(null);
  const [availableMaxDate, setAvailableMaxDate] = React.useState(null);
  const [selectedProduct, setSelectedProduct] = React.useState([]);
  const [productData, setProductData] = React.useState([]);
  const [yoyByBrand, setYoyByBrand] = React.useState([]);
  const [selectedBrand, setSelectedBrand] = React.useState(null);
  const TARGET_COMPARE_RATE = {
    2023: 1.09,
    2024: 1.09,
    2025: 1.09,
    2026: 1.1,
  };
  const overAllTrendInit = {
    YoY: {
      value: [0, 0],
      trend: 0,
    },
    YTDoYTD: {
      value: [0, 0],
      trend: 0,
    },
    MoM: {
      value: [0, 0],
      trend: 0,
    },
  };
  const [overAllTrend, setOverAllTrend] = React.useState(overAllTrendInit);
  const monthList = moment.monthsShort();

  const [thisYearAllBrandTotal, setThisYearAllBrandTotal] = React.useState(0);
  const [lastYearAllBrandTotal, setLastYearAllBrandTotal] = React.useState(0);
  const [thisYearMonthAllBrandTotal, setThisYearMonthAllBrandTotal] =
    React.useState(0);
  const [lastYearMonthAllBrandTotal, setLastYearMonthAllBrandTotal] =
    React.useState(0);

  const thisYear = moment().format("YYYY");
  const lastYear = moment().subtract(1, "Y").format("YYYY");
  const lastTwoYear = moment().subtract(2, "Y").format("YYYY");
  const productSummaryInit = {
    YoY: {
      value: [0, 0],
      trend: 0,
    },
    YTDoYTD: {
      value: [0, 0],
      trend: 0,
    },
    MoM: {
      value: [0, 0],
      trend: 0,
    },
  };
  const [productSummary, setProductSummary] =
    React.useState(productSummaryInit);

  const overAllLineChartInitData = {
    loading: true,
    margin: { right: 15, left: 70 },
    series: [
      {
        data: [],
        label: lastTwoYear,
        curve: "linear",
        valueFormatter: (value) => `${currencyFormat(value)}`,
      },
      {
        data: [],
        label: lastYear,
        curve: "linear",
        color: "#edc949",
        valueFormatter: (value) => `${currencyFormat(value)}`,
      },
      {
        data: [],
        label: thisYear,
        curve: "linear",
        valueFormatter: (value) => `${currencyFormat(value)}`,
      },
    ],
    height: 300,
  };
  const [overAllLineChartData, setOverAllLineChartData] = React.useState(
    overAllLineChartInitData
  );
  const resetChart = () => {
    setLastUpdatedDate(null);
    setSelectedProduct([]);
    setProductData([]);
    setYoyByBrand([]);
    setSelectedBrand(null);
    setOverAllTrend(overAllTrendInit);
    setThisYearAllBrandTotal(0);
    setLastYearAllBrandTotal(0);
    setThisYearMonthAllBrandTotal(0);
    setLastYearMonthAllBrandTotal(0);
    setProductSummary(productSummaryInit);
    setOverAllLineChartData(overAllLineChartInitData);
  };
  const handleProductChange = async (value) => {
    if (value.length <= 0) return;
    const {
      data: { summary },
    } = await getSummaryByProduct(value, lastUpdatedDate);
    const barChartData = {
      xAxis: [
        {
          data: monthList,
          scaleType: "band",
          id: "axis1",
        },
      ],
      series: [],
      margin: { right: 5, left: 70 },
      height: 400,
    };
    const productTrend = {
      YoY: {
        value: [0, 0],
        trend: 0,
      },
      YTDoYTD: {
        value: [0, 0],
        trend: 0,
      },
      MoM: {
        value: [0, 0],
        trend: 0,
      },
    };
    const thisYearYoY = [
      moment(lastUpdatedDate).startOf("month"),
      moment(lastUpdatedDate),
    ];
    const lastYearYoY = [
      moment(lastUpdatedDate).subtract(1, "year").startOf("month"),
      moment(lastUpdatedDate).subtract(1, "year"),
    ];
    const thisYearYTDoYTD = [
      moment(lastUpdatedDate).startOf("year"),
      moment(lastUpdatedDate),
    ];
    const lastYearYTDoYTD = [
      moment(lastUpdatedDate).subtract(1, "year").startOf("year"),
      moment(lastUpdatedDate).subtract(1, "year"),
    ];
    const thisYearMoM = [
      moment(lastUpdatedDate).startOf("month"),
      moment(lastUpdatedDate),
    ];
    const lastYearMoM = [
      moment(lastUpdatedDate).subtract(1, "month").startOf("month"),
      moment(lastUpdatedDate).subtract(1, "month"),
    ];
    let colorIndex = 0;

    const groupByProducts = _.groupBy(summary, "product_name");
    _.forEach(groupByProducts, (groupByProduct, product_name) => {
      let seriesData = [];
      const groupByYears = _.groupBy(groupByProduct, (p) =>
        moment(p.tx_date).format("YYYY")
      );
      const color = cheerfulFiestaPalette()[colorIndex] ?? getRandomColor();
      _.forEach(groupByYears, (groupByYearValue, year) => {
        _.forEach(monthList, (m) => {
          seriesData[m] = 0;
        });
        let series = {};

        series.label = `${year} - ${product_name}`;
        series.stack = year;
        series.color = color;
        const groupByMonth = _.groupBy(groupByYearValue, (p) =>
          moment(p.tx_date).format("MMM")
        );
        _.forEach(groupByMonth, (values, month) => {
          _.forEach(values, (v) => {
            if (
              moment(v.tx_date).isBetween(
                thisYearMoM[0],
                thisYearMoM[1],
                undefined,
                "[]"
              )
            ) {
              productTrend.MoM.value[0] += parseInt(v.sum);
            } else if (
              moment(v.tx_date).isBetween(
                lastYearMoM[0],
                lastYearMoM[1],
                undefined,
                "[]"
              )
            ) {
              productTrend.MoM.value[1] += parseInt(v.sum);
            }
            //YOY

            if (
              moment(v.tx_date).isBetween(
                thisYearYoY[0],
                thisYearYoY[1],
                undefined,
                "[]"
              )
            ) {
              productTrend.YoY.value[0] += parseInt(v.sum);
            } else if (
              moment(v.tx_date).isBetween(
                lastYearYoY[0],
                lastYearYoY[1],
                undefined,
                "[]"
              )
            ) {
              productTrend.YoY.value[1] += parseInt(v.sum);
            }
            //YTDoYTD
            if (
              moment(v.tx_date).isBetween(
                thisYearYTDoYTD[0],
                thisYearYTDoYTD[1],
                undefined,
                "[]"
              )
            ) {
              productTrend.YTDoYTD.value[0] += parseInt(v.sum);
            } else if (
              moment(v.tx_date).isBetween(
                lastYearYTDoYTD[0],
                lastYearYTDoYTD[1],
                undefined,
                "[]"
              )
            ) {
              productTrend.YTDoYTD.value[1] += parseInt(v.sum);
            }
          });
          seriesData[month] = _.sumBy(values, (v) => parseInt(v.sum));
        });
        series.data = _.values(seriesData);
        series.valueFormatter = (value) => `${currencyFormat(value)}`;
        barChartData.series.push(series);
      });
      colorIndex++;
    });
    setProductSummary({
      ...productTrend,
      barChartData,
    });
  };
  const fetch = async (selectedDate) => {
    let _thisYearAllBrandTotal = 0;
    let _lastYearAllBrandTotal = 0;
    let _thisYearMonthAllBrandTotal = 0;
    let _lastYearMonthAllBrandTotal = 0;
    resetChart();
    const convert = {};
    const {
      data: { maxDate },
    } = await getMaxDate();
    setAvailableMaxDate(maxDate);
    if (!selectedDate) {
      selectedDate = maxDate;
    }
    const thisYear = moment(selectedDate).format("YYYY");
    const lastYear = moment(selectedDate).subtract(1, "Y").format("YYYY");
    const lastTwoYear = moment(selectedDate).subtract(2, "Y").format("YYYY");

    const {
      data: { summary },
    } = await getSummaryByBrand(moment(selectedDate).format("YYYY-MM-DD"));
    const { data } = await getStatisticsProduct();
    setProductData(data);
    setLastUpdatedDate(moment(selectedDate).format("YYYY-MM-DD"));
    const groupByYearMonth = _.groupBy(summary, (d) =>
      moment(d.tx_date).format("YYYY-MM")
    );
    const sparkLinemonthList = enumerateDaysBetweenDates(
      moment(selectedDate).subtract(1, "year").startOf("year"),
      selectedDate,
      "YYYY-MM",
      "months"
    );
    const lineChartSeries = {
      ...overAllLineChartInitData,
      series: [
        {
          data: [],
          label: moment(selectedDate).subtract(2, "Y").format("YYYY"),
          curve: "linear",
          valueFormatter: (value) => `${currencyFormat(value)}`,
        },
        {
          data: [],
          label: moment(selectedDate).subtract(1, "Y").format("YYYY"),
          curve: "linear",
          color: "#edc949",
          valueFormatter: (value) => `${currencyFormat(value)}`,
        },
        {
          data: [],
          label: moment(selectedDate).format("YYYY"),
          curve: "linear",
          valueFormatter: (value) => `${currencyFormat(value)}`,
        },
      ],
    };
    const thisYearYoY = [
      moment(selectedDate).startOf("month"),
      moment(selectedDate),
    ];
    const lastYearYoY = [
      moment(selectedDate).subtract(1, "year").startOf("month"),
      moment(selectedDate).subtract(1, "year"),
    ];
    const thisYearYTDoYTD = [
      moment(selectedDate).startOf("year"),
      moment(selectedDate),
    ];
    const lastYearYTDoYTD = [
      moment(selectedDate).subtract(1, "year").startOf("year"),
      moment(selectedDate).subtract(1, "year"),
    ];
    const thisYearMoM = [
      moment(selectedDate).startOf("month"),
      moment(selectedDate),
    ];
    const lastYearMoM = [
      moment(selectedDate).subtract(1, "month").startOf("month"),
      moment(selectedDate).subtract(1, "month"),
    ];
    _.forEach(groupByYearMonth, (value, key) => {
      if (moment(key).isSame(thisYear, "year")) {
        lineChartSeries.series[2].data.push(
          _.sumBy(value, (v) => parseInt(v.sum))
        );
      } else if (moment(key).isSame(lastYear, "year")) {
        lineChartSeries.series[1].data.push(
          _.sumBy(value, (v) => parseInt(v.sum))
        );
      } else if (moment(key).isSame(lastTwoYear, "year")) {
        lineChartSeries.series[0].data.push(
          _.sumBy(value, (v) => parseInt(v.sum))
        );
      }
    });
    const groupByBrand = _.groupBy(summary, "brand_types_name");

    _.forEach(groupByBrand, (value, key) => {
      let thisYearYtdTotal = 0;
      let lastYearYtdTotal = 0;
      let seriesData = [{}, {}];
      _.forEach(monthList, (m) => {
        seriesData[0][m] = 0;
        seriesData[1][m] = 0;
      });
      convert[key] = {
        YoY: {
          trend: "up",
          trendValues: "",
          thisYearTotal: 0,
          lastYearTotal: 0,
        },
        YTDoYTD: {
          trend: "up",
          trendValues: "",
          thisYearTotal: 0,
          lastYearTotal: 0,
        },
        OVERALL: {
          thisYearTotal: 0,
          lastYearTotal: 0,
        },
        barChartData: {
          loading: true,
          xAxis: [
            {
              data: monthList,
              scaleType: "band",
              id: "axis1",
            },
          ],
          series: [
            {
              data: [],
              label: lastYear,
              color: "#edc949",
              valueFormatter: (value) => `${currencyFormat(value)}`,
            },
            {
              data: [],
              label: thisYear,
              valueFormatter: (value) => `${currencyFormat(value)}`,
            },
          ],
          margin: { right: 5, left: 70 },
          height: 600,
        },
        brand: key,
        overAllTotal: 0,
        MoM: { lastYear: 0, thisYear: 0 },
        thisYear: thisYear,
        lastYear: lastYear,
        sparkLineChartData: {
          data: [],
          daysInWeek: sparkLinemonthList,
        },
      };

      const _overAllTrend = { ...overAllTrendInit };
      const groupBrandByYearMonth = _.groupBy(value, (v) =>
        moment(v.tx_date).format("YYYY-MM")
      );
      const sortByDate = _.sortBy(groupBrandByYearMonth, "tx_date");
      const sparkLineChartData = {};

      _.forEach(sparkLinemonthList, (m) => {
        sparkLineChartData[m] = 0;
      });
      _.forEach(sortByDate, (v) => {
        const sumOfMonth = _.sumBy(v, (_v) => parseInt(_v.sum));
        const yearMonthString = moment(v[0].tx_date).format("YYYY-MM");
        const month = moment(v[0].tx_date).format("MMM");
        const year = moment(v[0].tx_date).format("YYYY");
        if (year === thisYear) {
          seriesData[1][month] = sumOfMonth;
          sparkLineChartData[yearMonthString] = sumOfMonth;
        } else if (year === lastYear) {
          seriesData[0][month] = sumOfMonth;
          sparkLineChartData[yearMonthString] = sumOfMonth;
        }
        convert[key].barChartData.loading = false;
        convert[key].barChartData.series[0].data = _.values(seriesData[0]);
        convert[key].barChartData.series[1].data = _.values(seriesData[1]);

        _.forEach(v, (_v) => {
          //Monthly Achievement rate
          if (
            moment(_v.tx_date).isBetween(
              thisYearMoM[0],
              thisYearMoM[1],
              undefined,
              "[]"
            )
          ) {
            _thisYearMonthAllBrandTotal += parseInt(_v.sum);
          } else if (
            moment(_v.tx_date).isBetween(
              moment(selectedDate).subtract(1, "year").startOf("month"),
              moment(selectedDate).subtract(1, "year").endOf("month"),
              undefined,
              "[]"
            )
          ) {
            _lastYearMonthAllBrandTotal += parseInt(_v.sum);
          }
          //MoM
          if (
            moment(_v.tx_date).isBetween(
              thisYearMoM[0],
              thisYearMoM[1],
              undefined,
              "[]"
            )
          ) {
            _overAllTrend.MoM.value[0] += parseInt(_v.sum);
          } else if (
            moment(_v.tx_date).isBetween(
              lastYearMoM[0],
              lastYearMoM[1],
              undefined,
              "[]"
            )
          ) {
            _overAllTrend.MoM.value[1] += parseInt(_v.sum);
          }
          //YOY

          if (
            moment(_v.tx_date).isBetween(
              thisYearYoY[0],
              thisYearYoY[1],
              undefined,
              "[]"
            )
          ) {
            _overAllTrend.YoY.value[0] += parseInt(_v.sum);
            convert[key]["YoY"].thisYearTotal += parseInt(_v.sum);
          } else if (
            moment(_v.tx_date).isBetween(
              lastYearYoY[0],
              lastYearYoY[1],
              undefined,
              "[]"
            )
          ) {
            _overAllTrend.YoY.value[1] += parseInt(_v.sum);
            convert[key]["YoY"].lastYearTotal += parseInt(_v.sum);
          }
          //YTDoYTD
          if (
            moment(_v.tx_date).isBetween(
              thisYearYTDoYTD[0],
              thisYearYTDoYTD[1],
              undefined,
              "[]"
            )
          ) {
            _overAllTrend.YTDoYTD.value[0] += parseInt(_v.sum);
            convert[key]["YTDoYTD"].thisYearTotal += parseInt(_v.sum);
            thisYearYtdTotal += parseInt(_v.sum);
          } else if (
            moment(_v.tx_date).isBetween(
              lastYearYTDoYTD[0],
              lastYearYTDoYTD[1],
              undefined,
              "[]"
            )
          ) {
            _overAllTrend.YTDoYTD.value[1] += parseInt(_v.sum);
            convert[key]["YTDoYTD"].lastYearTotal += parseInt(_v.sum);
            lastYearYtdTotal += parseInt(_v.sum);
          }
        });
        const thisYearTotal = _.chain(v)
          .filter((d) => moment(d.tx_date).isSame(thisYear, "year"))
          .sumBy((d) => parseInt(d.sum))
          .value();
        const lastYearTotal = _.chain(v)
          .filter((d) => moment(d.tx_date).isSame(lastYear, "year"))
          .sumBy((d) => parseInt(d.sum))
          .value();

        _thisYearAllBrandTotal += thisYearTotal;
        _lastYearAllBrandTotal += lastYearTotal;
        // convert[key].barChartData.series[0].data = _.values(barChartData);
        convert[key].sparkLineChartData.data = _.values(sparkLineChartData);
        convert[key].sparkLineChartData.trendValues = `${
          thisYearYtdTotal > lastYearYtdTotal ? "+" : ""
        }${_.round(
          ((thisYearYtdTotal - lastYearYtdTotal) / lastYearYtdTotal) * 100,
          1
        )}%`;
        convert[key].overAllTotal = thisYearYtdTotal + lastYearYtdTotal;
      });

      _.forEach(["YoY", "YTDoYTD"], (type) => {
        if (
          convert[key][type].thisYearTotal === convert[key][type].lastYearTotal
        ) {
          convert[key][type].trend = "neutral";
        } else if (
          convert[key][type].thisYearTotal < convert[key][type].lastYearTotal
        ) {
          convert[key][type].trend = "down";
        }

        convert[key][type].trendValues = _.round(
          ((convert[key][type].thisYearTotal -
            convert[key][type].lastYearTotal) /
            convert[key][type].lastYearTotal) *
            100,
          1
        );
      });
      setOverAllTrend(_overAllTrend);
    });
    const barChartData = {
      xAxis: [
        {
          data: monthList,
          scaleType: "band",
          id: "axis1",
        },
      ],
      series: [],
      margin: { right: 5, left: 70 },
      height: 400,
    };
    setProductSummary({ ...productSummary, barChartData });
    setSelectedBrand(
      _.orderBy(convert, ["YoY.thisYearTotal"], ["desc"])[0].brand
    );
    setThisYearAllBrandTotal(_thisYearAllBrandTotal);
    setLastYearAllBrandTotal(_lastYearAllBrandTotal);
    setThisYearMonthAllBrandTotal(_thisYearMonthAllBrandTotal);
    setLastYearMonthAllBrandTotal(_lastYearMonthAllBrandTotal);
    setYoyByBrand(convert);
    setOverAllLineChartData({
      ...lineChartSeries,
      loading: false,
    });
  };
  React.useEffect(() => {
    fetch();
  }, []);

  return (
    <Layout header="Main Page" selectedIndex={1} open={open} setOpen={setOpen}>
      <Grid container spacing={1} columns={14}>
        <Grid size={14} sx={{ textAlign: "center" }}>
          <DatePicker
            label="Last Update Date"
            value={lastUpdatedDate}
            maxDate={availableMaxDate}
            onChange={(newValue) => {
              fetch(newValue);
            }}
            renderInput={(params) => <TextField {...params} />}
          />
          {/* Last Update Date：{lastUpdatedDate} */}
        </Grid>
        <Grid container size={14}>
          <Grid size={2}>
            <GaugeChartCard
              caption={`${currencyFormat(
                thisYearAllBrandTotal
              )} / ${currencyFormat(
                lastYearAllBrandTotal * TARGET_COMPARE_RATE[thisYear]
              )}`}
              height={100}
              fontSize={22}
              value={_.round(
                (thisYearAllBrandTotal /
                  (lastYearAllBrandTotal * TARGET_COMPARE_RATE[thisYear])) *
                  100,
                1
              )}
              name={"Yearly Achievement rate"}
            ></GaugeChartCard>
          </Grid>
          <Grid size={2}>
            <GaugeChartCard
              height={100}
              fontSize={22}
              caption={`${moment(lastUpdatedDate).dayOfYear()} / ${
                moment(lastUpdatedDate).isLeapYear() ? 366 : 365
              } Day`}
              value={_.round(
                (moment(lastUpdatedDate).dayOfYear() /
                  (moment(lastUpdatedDate).isLeapYear() ? 366 : 365)) *
                  100,
                1
              )}
              name={"Yearly Time gone"}
            ></GaugeChartCard>
          </Grid>
          <Grid size={2}>
            <GaugeChartCard
              caption={`${currencyFormat(
                thisYearMonthAllBrandTotal
              )} / ${currencyFormat(
                lastYearMonthAllBrandTotal * TARGET_COMPARE_RATE[thisYear]
              )}`}
              height={100}
              fontSize={22}
              value={_.round(
                (thisYearMonthAllBrandTotal /
                  (lastYearMonthAllBrandTotal *
                    TARGET_COMPARE_RATE[thisYear])) *
                  100,
                1
              )}
              name={"Monthly Achievement rate"}
            ></GaugeChartCard>
          </Grid>
          <Grid size={2}>
            <GaugeChartCard
              caption={`${moment(lastUpdatedDate).format("D")} / ${moment(
                lastUpdatedDate
              ).daysInMonth()} Day`}
              height={100}
              fontSize={22}
              value={_.round(
                (parseInt(moment(lastUpdatedDate).format("D")) /
                  moment(lastUpdatedDate).daysInMonth()) *
                  100,
                1
              )}
              name={"Monthly Time gone"}
            ></GaugeChartCard>
          </Grid>
          <Grid size={2}>
            <TrendCard
              height={120}
              fontSize={22}
              variant={"h3"}
              data={overAllTrend.YoY}
              name={"YoY"}
            ></TrendCard>
          </Grid>
          <Grid size={2}>
            <TrendCard
              height={120}
              fontSize={22}
              variant={"h3"}
              data={overAllTrend.YTDoYTD}
              name={"YTDoYTD"}
            ></TrendCard>
          </Grid>
          <Grid size={2}>
            <TrendCard
              height={120}
              fontSize={22}
              variant={"h3"}
              data={overAllTrend.MoM}
              name={"MoM"}
            ></TrendCard>
          </Grid>
          <Grid size={14}>
            <LineChartCard
              data={overAllLineChartData}
              name={"OVERALL"}
            ></LineChartCard>
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={1} columns={12}>
        <Grid size={12} sx={{ margin: 1 }}>
          <Typography variant={"h4"} sx={{ textAlign: "center" }}>
            YTDoYTD By Brand
          </Typography>
        </Grid>
        {Object.keys(yoyByBrand).length > 0 ? (
          _.map(
            _.orderBy(yoyByBrand, ["YTDoYTD.thisYearTotal"], ["desc"]),
            (data) => {
              if (
                data["YTDoYTD"].lastYearTotal !== 0 ||
                data["YTDoYTD"].thisYearTotal !== 0
              )
                return (
                  <Grid size={2}>
                    <SparkLineChartCard
                      handleOnClick={() => {
                        setSelectedBrand(data.brand);
                      }}
                      chartData={data.sparkLineChartData}
                      data={data}
                      type={"YTDoYTD"}
                      selectedBrand={data.brand}
                      showChart
                    />
                  </Grid>
                );
            }
          )
        ) : (
          <Box
            sx={{
              width: "100%",
              minHeight: 100,
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CircularProgress></CircularProgress>
          </Box>
        )}

        <Grid size={12}>
          {yoyByBrand[selectedBrand]?.barChartData && (
            <BarChartCard
              name={selectedBrand}
              data={yoyByBrand[selectedBrand]?.barChartData}
            ></BarChartCard>
          )}
        </Grid>
        <Grid size={12} sx={{ margin: 1 }}>
          <Typography variant={"h4"} sx={{ textAlign: "center" }}>
            YoY By Brand
          </Typography>
        </Grid>
        {Object.keys(yoyByBrand).length > 0 ? (
          _.map(
            _.orderBy(yoyByBrand, ["YoY.thisYearTotal"], ["desc"]),
            (data) => {
              if (
                data["YoY"].lastYearTotal !== 0 ||
                data["YoY"].thisYearTotal !== 0
              )
                return (
                  <Grid size={2}>
                    <SparkLineChartCard
                      handleOnClick={() => {
                        setSelectedBrand(data.brand);
                      }}
                      chartData={data.sparkLineChartData}
                      data={data}
                      type={"YoY"}
                      selectedBrand={data.brand}
                      showChart
                    />
                  </Grid>
                );
            }
          )
        ) : (
          <Box
            sx={{
              width: "100%",
              minHeight: 100,
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CircularProgress></CircularProgress>
          </Box>
        )}
      </Grid>
      <Grid
        container
        columns={12}
        spacing={2}
        sx={{ marginTop: 2, marginBottom: 2 }}
      >
        <Grid size={12} sx={{ margin: 1 }}>
          <Typography variant={"h4"} sx={{ textAlign: "center" }}>
            By Product
          </Typography>
        </Grid>
        <Grid size={2}>
          <Grid container columns={2} spacing={1}>
            <Grid size={12}>
              <ProductAutoComplete
                selectByCategory
                id={"product-auto-0"}
                multiple
                fullWidth
                productOptions={productData}
                handleOnChange={(value) => {
                  setSelectedProduct(value);
                }}
                onClose={() => handleProductChange(selectedProduct)}
                selectedValue={selectedProduct}
                error={selectedProduct.length <= 0}
              ></ProductAutoComplete>
            </Grid>
            {selectedProduct.length > 0 && (
              <React.Fragment>
                <Grid size={12}>
                  <TrendCard
                    height={50}
                    fontSize={12}
                    variant={"h4"}
                    data={productSummary.YoY}
                    name={"YoY"}
                  ></TrendCard>
                </Grid>
                <Grid size={12}>
                  <TrendCard
                    height={50}
                    fontSize={12}
                    variant={"h4"}
                    data={productSummary.YTDoYTD}
                    name={"YTDoYTD"}
                  ></TrendCard>
                </Grid>
                <Grid size={12}>
                  <TrendCard
                    height={50}
                    fontSize={12}
                    variant={"h4"}
                    data={productSummary.MoM}
                    name={"MoM"}
                  ></TrendCard>
                </Grid>
              </React.Fragment>
            )}
          </Grid>
        </Grid>
        <Grid size={10}>
          {productSummary.barChartData && (
            <BarChartCard
              hiddenLegend={true}
              data={productSummary.barChartData}
              height={600}
            ></BarChartCard>
          )}
        </Grid>
      </Grid>
    </Layout>
  );
};

export default ManningsDashBoardPage;
